import API_CONSTANT from 'constants/apiConstant';
import { put, takeEvery } from 'redux-saga/effects';
import { triggerFetchPostPeContactListApiCallSuccess } from 'redux/actions';
import { TRIGGER_FETCH_POSTPE_CONTACT_LIST_API } from 'redux/actionTypes';
import { apiCall } from 'services';

function* triggerFetchPostPeContactListApiCall(actions) {
	const { callback, stopLoader } = actions;
	const api = yield apiCall({
		urlType: API_CONSTANT.URL_TYPE.POST_PE_V1,
		url: API_CONSTANT.URL.POSTPE_CONTACT_LIST,
		method: 'GET',
		options: {
			defaultLoader: !stopLoader,
		},
	});
	console.log(api);
	if (api && api.data) {
		const apiData = api.data.data;
		callback && callback(apiData.activeReferrals); //storing only active referrals
		yield put(triggerFetchPostPeContactListApiCallSuccess(apiData.activeReferrals));
	}
}

export default function* triggerFetchPostPeContactListApiCallSaga() {
	yield takeEvery(TRIGGER_FETCH_POSTPE_CONTACT_LIST_API, triggerFetchPostPeContactListApiCall);
}
